var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4255 9.25595C20.3574 8.82934 19.9564 8.53871 19.5297 8.60677C19.1031 8.67483 18.8125 9.07587 18.8806 9.50248C18.8813 9.50716 18.8821 9.51179 18.8829 9.51642C19.6795 14.2056 16.5239 18.6527 11.8347 19.4493C7.14547 20.2458 2.69839 17.0903 1.90181 12.401C1.10524 7.71184 4.26088 3.26477 8.95005 2.46819C11.8338 1.97833 14.7691 2.98565 16.7443 5.14304L13.2791 6.29757C12.8692 6.43397 12.6475 6.87681 12.7839 7.28674C12.7839 7.28683 12.784 7.28697 12.784 7.28706C12.9204 7.69699 13.3633 7.91868 13.7732 7.78233C13.7733 7.78229 13.7734 7.78224 13.7735 7.78224L18.4668 6.21783C18.7863 6.1114 19.0019 5.81234 19.0018 5.47552V0.78223C19.0018 0.350209 18.6516 0 18.2196 0C17.7876 0 17.4374 0.350209 17.4374 0.78223V3.63963C13.409 -0.19181 7.03739 -0.0321745 3.20594 3.99617C-0.625505 8.02451 -0.465914 14.3962 3.56248 18.2276C7.59087 22.0591 13.9625 21.8995 17.794 17.8711C19.9788 15.574 20.9538 12.3818 20.4255 9.25595Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.db2e9f43.svg";
export { ForwardRef as ReactComponent };